export default __webpack_public_path__ + "static/media/bg.38cad19f.jpg";